
/**
 *环境核心代码
 *
 * @class Env
 */
class Env {
  /**
   *Creates an instance of Env.
   *加载参数
   *初始化
   * @param {*} [options={}]
   * @memberof Env
   */
  constructor(options = {}) {
    this.options = options;
    this.init();
  }
  /**
   *初始化
   *
   * @memberof Env
   */
  init() {
    this.initData();
    this.register();
  }
  /**
   *初始化数据
   *
   * @memberof Env
   */
  initData() {
    // 环境名称
    this.envNames = [];

    // 注册的环境类
    this.registerEnv = [];
    // 注册的环境实例
    this.registerInstance = {};

    this.defineData();
  }
  /**
   *定义变量
   *
   * @returns
   * @memberof Env
   */
  defineData() {
    const that = this;

    Object.defineProperty(this, 'name', {
      get() {
        return that.getEnvName();
      },
    });

    Object.defineProperty(this, 'allName', {
      get() {
        return that.getEnvName('ALL');
      },
    });

    Object.defineProperty(this, 'instance', {
      get() {
        return that.registerInstance[that.getEnvName()];
      },
    });

    Object.defineProperty(this, 'phoneSys', {
      get() {
        return Env.getPhoneSys();
      },
    });

    Object.defineProperty(this, 'wsPid', {
      get() {
        return that.getWsPid();
      },
    });
  }
  /**
   *动态注册环境
   *
   * @param {*} EnvClass
   * @memberof Env
   */
  dynamicRegister(EnvClass) {
    const envName = EnvClass.envName();
    if (!(this.registerInstance[envName] instanceof EnvClass)) {
      this.registerInstance[envName] = new EnvClass(this, {});
    }
  }
  /**
   *注册环境
   *
   * @memberof Env
   */
  register() {
    this.registerEnv.forEach((EnvClass) => {
      const envName = EnvClass.envName();
      if (!(this.registerInstance[envName] instanceof EnvClass)) {
        this.registerInstance[envName] = new EnvClass(this, {});
      }
    });
  }
  /**
   *获得环境名称
   *1. 有可能同时匹配多个环境
   *2. 一般情况下匹配一个环境
   * @param {string} [type='']
   * @returns
   * @memberof Env
   */
  getEnvName(type = '') {
    if (type === 'ALL') return this.envNames;

    return this.envNames[0];
  }
  /**
   *设置环境名称
   *
   * @param {string} [env='']
   * @memberof Env
   */
  setEnvName(env = '') {
    if (env === 'wx') {
      if (this.envNames[0] !== 'mini') this.envNames.push(env);
    } else {
      this.envNames.push(env);
    }
    // 如果存在小程序环境，则删除微信内置浏览器环境
    // this.pureEnvName();
  }
  // pureEnvName() {
  //   if (['mini', 'wx'].every(envName => this.envNames.indexOf(envName) > -1)) {
  //     this.envNames = this.envNames.filter(envName => envName !== 'wx');
  //   }
  // }
  static getPhoneSys() {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isAndroid) return 'android';
    if (isiOS) return 'ios';
    return 'others';
  }
  /**
   *判断是否是函数
   *
   * @static
   * @param {*} func
   * @returns
   * @memberof Env
   */
  static isFunc(func) {
    return typeof func === 'function';
  }

  /*        抹平各个环境的方法入口      */
  invoke(opt = {}) {
    if (Env.isFunc(this.instance.invoke)) this.instance.invoke(opt);
  }
  redirectTo(opt = {}) {
    if (Env.isFunc(this.instance.redirectTo)) this.instance.redirectTo(opt);
  }
  navigateTo(opt = {}) {
    if (Env.isFunc(this.instance.navigateTo)) this.instance.navigateTo(opt);
  }
  navigateBack(opt = {}) {
    if (Env.isFunc(this.instance.navigateBack)) this.instance.navigateBack(opt);
  }
  postMessages(opt = {}) {
    if (Env.isFunc(this.instance.postMessages)) this.instance.postMessages(opt);
  }
  share(opt = {}) {
    if (Env.isFunc(this.instance.share)) return this.instance.share(opt);
    return Promise.reject();
  }
  login(opt = {}) {
    if (Env.isFunc(this.instance.login)) return this.instance.login(opt);
    return true;
  }
  getWsPid() {
    if (!this.instance) return '';
    if (Env.isFunc(this.instance.getWsPid)) return this.instance.getWsPid();
    return '';
  }
  closeWindow(opt) {
    if (Env.isFunc(this.instance.closeWindow)) this.instance.closeWindow(opt);
  }
}

let envInstance = null;

// 生成单例
export const env = (() => {
  if (!(envInstance instanceof Env)) envInstance = new Env();
  return envInstance;
})();

export default {
  /**
   *Vue插件入口
   *
   * @param {*} Vue
   */
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$env', {
      value: env,
    });
  },
};



// WEBPACK FOOTER //
// ./src/utils/Env/index.js